import { render } from "react-dom";
import CookiePlaceholder from "./CookiePlaceholder";

const executeScripts = (root: Element) => {
  const scripts = Array.from(root.querySelectorAll("script"));

  scripts.forEach((oldScript) => {
    const newScript = document.createElement("script");

    Array.from(oldScript.attributes).forEach((attr) => {
      newScript.setAttribute(attr.name, attr.value);
    });

    newScript.textContent = oldScript.textContent;
    newScript.async = false;
    // Consent is already gated; stop Cookiebot from blocking the re-inserted tag
    newScript.setAttribute("data-cookieconsent", "ignore");

    // Uitdatabank widgets use document.write(), which browsers ignore after load.
    // data-render-to is their supported alternative for delayed insertion.
    if (/uitdatabank\.be/i.test(newScript.src)) {
      document.documentElement.classList.remove("widgets_bootstrapped");

      if (!newScript.getAttribute("data-render-to")) {
        const targetId = `embed-render-${Math.random()
          .toString(36)
          .slice(2, 10)}`;
        const target = document.createElement("div");
        target.id = targetId;
        oldScript.parentNode?.insertBefore(target, oldScript);
        newScript.setAttribute("data-render-to", `#${targetId}`);
      }
    }

    const originalWrite = document.write.bind(document);
    const originalWriteln = document.writeln.bind(document);
    const insertMarkup = (...markup: string[]) => {
      newScript.insertAdjacentHTML("beforebegin", markup.join(""));
    };

    document.write = insertMarkup;
    document.writeln = insertMarkup;

    const restoreWrite = () => {
      document.write = originalWrite;
      document.writeln = originalWriteln;
    };

    if (newScript.src) {
      newScript.addEventListener("load", restoreWrite, { once: true });
      newScript.addEventListener("error", restoreWrite, { once: true });
    }

    oldScript.parentNode?.replaceChild(newScript, oldScript);

    if (!newScript.src) {
      restoreWrite();
    }
  });
};

(() => {
  const embedContainers = document.querySelectorAll("[data-embed-container]");

  if (embedContainers.length === 0) return;

  const handleConsent = (container: Element) => {
    // Clear existing content
    container.innerHTML = "";

    if (!window.Cookiebot) return;

    if (window.Cookiebot?.consent?.marketing) {
      const rawContent = container.getAttribute("data-html-content");
      const htmlContent = rawContent ? decodeURIComponent(rawContent) : "";
      container.innerHTML = htmlContent;
      // innerHTML does not execute <script> tags; recreate them so widgets load
      executeScripts(container);

      if (
        htmlContent.includes("tiktok.com") &&
        !htmlContent.includes("tiktok.com/embed.js")
      ) {
        const script = document.createElement("script");
        script.src = "https://www.tiktok.com/embed.js";
        script.async = true;
        document.body.appendChild(script);
      }
    } else {
      const placeholder = document.createElement("div");
      placeholder.setAttribute("data-cookiebot-marketing-placeholder", "");
      container.appendChild(placeholder);
      render(<CookiePlaceholder />, placeholder);
    }
  };

  embedContainers.forEach(handleConsent);

  window.addEventListener("CookiebotOnAccept", () => {
    embedContainers.forEach(handleConsent);
  });

  window.addEventListener("CookiebotOnDecline", () => {
    embedContainers.forEach(handleConsent);
  });
})();

export { };
